var map = {
	"./_base-body-text.vue": "./src/components/_base/_base-body-text.vue",
	"./_base-subtitle.vue": "./src/components/_base/_base-subtitle.vue",
	"./_base-title.vue": "./src/components/_base/_base-title.vue",
	"./_base-version.vue": "./src/components/_base/_base-version.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/_base sync recursive _base-[\\w-]+\\.vue$";